/* eslint-disable react/prop-types */
import {useMemo} from 'react';

import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';

const {module: SelectionButton} = MojitoModules.SelectionButton;

const {FlexPane, Text, Image} = MojitoPresentation.Components;
const {EventFormatter} = MojitoPresentation.Utils;

const PriceBoostItem = props => {
    const {
        event,
        market,
        selection,
        mojitoTools: {config, l10n, stringResolver},
    } = props;

    const selectionLabel = useMemo(() => {
        if (selection.handicapLabel && !name.endsWith(selection.handicapLabel)) {
            return `${selection.name} ${selection.handicapLabel}`;
        }
        return selection.name;
    }, [selection.name, selection.handicapLabel]);

    return (
        <FlexPane class="ta-PriceBoostItem" config={config.container}>
            <FlexPane class="ta-labelContainer" config={config.labelContainer}>
                <Text config={config.selectionLabel}>{selectionLabel}</Text>
                {config.showMarketLabel && <Text config={config.marketLabel}>{market.name}</Text>}
            </FlexPane>
            <FlexPane class="ta-priceInformationContainer" config={config.priceInformationContainer}>
                <FlexPane config={config.wasContainer}>
                    <Text config={config.wasTitle}>{stringResolver.resolveString('$PRICE_BOOST_ITEM.WAS')}</Text>
                    <Text config={config.wasPrice}>
                        {EventFormatter.formatSelectionPrice([selection.basePrice], l10n)}
                    </Text>
                </FlexPane>
                <Image config={config.indicationIcon} />
                <SelectionButton
                    selection={selection}
                    event={event}
                    marketStatus={market.status}
                    marketType={market.type}
                    config={config.selectionButton}
                    marketId={market.id}
                />
            </FlexPane>
        </FlexPane>
    );
};

export default PriceBoostItem;
